import React, { Component } from "react";
import { Sidebarc } from "../src/Sidebar";
import { Appheaderc } from "./Appheader";
import { Button, Grid2, Paper, Typography,AvatarGroup,Avatar } from "@mui/material";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid";
import {
  Tooltip,
  IconButton,
  TableBody,
  Table,
  Modal,
  MenuItem,
  TableContainer,
  TablePagination,
  Divider,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from "@mui/material";
import base_url from "./baseurl";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import { ToastContainer, toast } from "react-toastify";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Chart from "react-apexcharts";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";




const drawerWidth = 235;
class OrderDescription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDetails : {},
    };
  }

  componentDidMount() {

    fetch(`${base_url.base_url}/order/singleOrderDetails`, {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body:JSON.stringify({
          order_id :  this.props.param.id.replace(/:/g,'')
        })
      })
        .then((res) => {
          return res.json();
        })
        .then((result) => {
            console.log(result)
        this.setState({
            orderDetails : result.data
        })
        });

  }



  render() {
    return (
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebarc />
          <Box
            sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
          >
            <Box sx={{ p: { xs: 1, sm: 3 }, mt: 6 }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: 16,
                  marginTop: 5,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
              >
                Order Description
              </Typography>
<Box>
        



<Paper sx={{minHeight:70}}>
<Box sx={{p:2}}>
<Grid2 container spacing={2} >

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>ORDER ID</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.order_id : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>CUSTOMER EMAIL</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.cust_email : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>ORDER DATE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{moment(this.state.orderDetails?this.state.orderDetails.order_date : "").format('DD-MM-YYYY')}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>STATUS</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.status : ""}</Typography>
</Grid2>



</Grid2>
</Box>
</Paper>


<Paper sx={{minHeight:70,mt:1}}>
<Typography sx={{fontSize:14,pl:1,pt:1,pl:2,fontWeight:'600'}}>DELIVERY ADDRESS</Typography>
<Box sx={{height:2,width:140,backgroundColor:'#1b7bce',ml:2,mb:1}}>

</Box>
<Box sx={{pl:2,pr:2,pb:2}}>
<Grid2 container spacing={2} >

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>FIRST NAME</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.firstname : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>LAST NAME</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.lastname : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>PHONE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.phone : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>POSTAL CODE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.postalcode : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>ADDRESS</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.adress : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>CITY </Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.city : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>COUNTRY</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.country : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>STATE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.state : ""}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>DELIVERY DATE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{moment(this.state.orderDetails?this.state.orderDetails.address?.delivery_date : "").format('DD-MM-YYYY')}</Typography>
</Grid2>

<Grid2 size={{xs:6,sm:4,md:2}}>
<Typography sx={{fontSize:13,color:'#1b7bce'}}>POSTAL CODE</Typography>
<Typography sx={{fontSize:12,color:'black',mt:0.5}}>{this.state.orderDetails?this.state.orderDetails.address?.postalcode : ""}</Typography>
</Grid2>


</Grid2>
</Box>
</Paper>


<Paper sx={{minHeight:70,mt:1}}>
<Typography sx={{fontSize:14,pl:1,pt:1,pl:2,fontWeight:'600'}}>ORDERD ITEMS LIST</Typography>
<Box sx={{height:2,width:140,backgroundColor:'#1b7bce',ml:2,mb:1}}>

</Box>
<Box sx={{ mt: 0 ,padding:1}}>
                  <TableContainer component={Box}>
                    <Table
                      sx={{ minWidth: 920 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                              fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`
                            }}
                          >
                           PRODUCT ID
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                              fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`
                            }}
                          >
                          PRODUCT NAME
                          </TableCell>
                            
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                              fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`
                            }}
                          >
                          WEIGHT
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                              fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`

                            }}
                          >
                            METAL TYPE
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                              fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`
                            }}
                          >
                            PRODUCT TYPE
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                              fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`
                            }}
                          >
                           THUMB NAIL IMAGE
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              textAlign:'center',
                              color: "#1b7bce",
                              fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`
                            }}
                          >
                           PRODUCT IMAGES
                          </TableCell>
             
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.orderDetails?.items?.map((row,i) => (
                          <TableRow
                            key={row.product_id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },backgroundColor:i%2?'#f4f4f4':'#fff'
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{ color: "#42526e", fontSize: 13 }}
                            >
                              <Button
                                variant="contained"
                                disableElevation
                                style={{
                                  height: 20,
                                  fontSize: 11,
                                  fontWeight: "600",
                                  color: "#fff",
                                }}
                              >
                                {row.product_id}
                              </Button>
                            </TableCell>
                        
                            <TableCell align="left" sx={{ color: "#42526e",fontSize:13 ,fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,textTransform:'capitalize',fontWeight:'500'}}>
                              {row.product_name}
                            </TableCell>  
                            
                              <TableCell align="left" sx={{ color: "#42526e",fontSize:13,fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,fontWeight:'500' }}>
                              {row.weight}
                            </TableCell>
                            <TableCell align="left" sx={{ color: "#42526e" ,fontSize:13,fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,textTransform:'capitalize',fontWeight:'500'}}>
                             {row.metal_type}
                            </TableCell>
                            <TableCell align="left" sx={{ color: "#42526e" ,fontSize:13,fontFamily:`"Roboto", "Helvetica", "Arial", sans-serif`,textTransform:'capitalize',fontWeight:'500'}}>
                            {row.product_type}
                            </TableCell>
                            <TableCell align="center" sx={{ color: "#42526e" ,fontSize:13}}>
                              <img src={`${base_url.base_url}/`+ row.thumb_nail_img} style={{height:70,width:100}}/>
                            </TableCell>
                            <TableCell align="center" sx={{ color: "#42526e" ,fontSize:13}}>
                            <AvatarGroup   max={4}>
                              {
                               row.productImage.map((i)=>(
                                <Avatar  alt="Remy Sharp" src={`${base_url.base_url}/`+ i.img_url} />
                               ))  
                              }
                            </AvatarGroup>
                            </TableCell>
       
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Divider />
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={this.state.size}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </Box>
</Paper>













</Box>

            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              position: "fixed",
              top: 0,
              left: { xs: 0, sm: 235 },
            }}
          >
            <Appheaderc />
          </Box>

        </Box>
      </div>
    );
  }
}

export default OrderDescription;


export function OrderDescriptionc(props){
    const navigate = useNavigate();
    const location = useLocation();
    const param = useParams();
    return (<OrderDescription param={param}  location={location} navigate={navigate}></OrderDescription>)
  }
  

